<template>
  <div class="dictindex">
    <el-card class="box-card">
      <!-- card header -->
      <div slot="header" class="clearfix">
        <span>业务与服务</span>
        <el-button
          class="tz-r tz-create-btn"
          type="primary"
          round
          @click="addMenu"
          >创建主菜单</el-button
        >
      </div>
      <!-- <div v-for="(item, i) in menuList" :key="i">
        <div
          v-for="(menu, j) in item.subOfficialWebsiteMenus"
          :class="menu.id == 14 ? 'disabled' : 'cardType'"
          @click="menu.id !== 14 ? toCreate(menu.type) : null"
          :key="j"
        >
          <span>
            {{ menu.title }}
          </span>
        </div>
      </div> -->
      <!-- ///// -->
      <!-- <div v-for="(item, i) in menuList" :key="i">
        <div
          style="
            display: flex;
            justify-content: space-between;
            margin-top: 20px;
            width: 100%;
          "
        >
          <input
            style="font-size: 18px; font-weight: bold; max-width: 200px"
            v-model="item.title"
            type="text"
            @change="productMenusUpdate(item)"
          />

          <div v-for="(menu, j) in item.subOfficialWebsiteMenus" :key="j">
            <input
              v-model="menu.title"
              type="text"
              @change="productMenusUpdate(menu)"
            />
          </div>
        </div>
      </div> -->
      <!-- card content -->

      <!-- 表格 -->
      <el-table
        default-expand-all
        :row-class-name="tableRowClassName"
        :data="menuList"
        style="width: 100%; margin-bottom: 20px"
        row-key="id"
        border
        :tree-props="{
          children: 'subOfficialWebsiteMenus',
          hasChildren: 'hasChildren'
        }"
      >
        <el-table-column prop="orders" label="排序">
          <template slot-scope="scope" v-if="scope.row.link">
            {{ scope.row.orders }}
          </template>
        </el-table-column>
        <el-table-column prop="title" label="菜单名称"> </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" @click="handleEdit(scope)"
              ><i class="el-icon-edit"></i>菜单</el-button
            >
            <el-button
              v-if="!scope.row.lastLevel && scope.row.type"
              size="mini"
              type="warning"
              @click="toCreate(scope.row)"
              ><i class="el-icon-edit-outline"></i>内容</el-button
            >
            <el-button
              v-if="scope.row.lastLevel"
              size="mini"
              @click="handleAddMenu(scope)"
              ><i class="el-icon-plus"></i> 子菜单</el-button
            >
            <el-button size="mini" type="danger" @click="handleDelete(scope)"
              ><i class="el-icon-delete"></i
            ></el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
    <!-- card -->
    <!-- 添加或修改菜单对话框 -->
    <el-dialog
      :title="title"
      :visible.sync="addOpen"
      width="500px"
      append-to-body
    >
      <el-form
        ref="form"
        :model="form"
        :rules="rules"
        label-width="136px"
        class="widthForm"
      >
        <el-form-item label="名称" prop="title">
          <el-input v-model="form.title"></el-input>
        </el-form-item>
        <el-form-item v-if="title == '添加子菜单'" label="排序" prop="orders">
          <el-input v-model="form.orders"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm">确 定</el-button>
        <el-button @click="cancel">取 消</el-button>
      </div>
    </el-dialog>
    <!-- 编辑弹框 -->
    <Edit
      :state="editState"
      @close="editState = false"
      :row="editUnit"
      @confirm="changeDict"
    />
    <!-- 编辑弹框 end -->
  </div>
</template>

<script>
// productAdd,
// productUpdate,
// productDelete,
// productDetail
import {
  productMenus,
  productMenusUpdate,
  menuAdd,
  menuDelete
} from '@/api/product'
// import TzTable from '@/components/tz-table/Index.vue'
import Edit from './components/Edit'
export default {
  components: {
    // TzTable,
    Edit
  },
  data() {
    return {
      page: 1, //当前页
      size: '10',
      total: 100,
      dictTypeValue: '',
      editState: false,
      editUnit: {},
      dictList: [],
      rules: {
        title: [{ required: true, message: '请输入名称', trigger: 'blur' }],
        orders: [{ required: true, message: '请输入排序', trigger: 'blur' }]
      },
      title: '',
      form: {
        title: '',
        orders: ''
      },
      ////1:检测检测 2:机管家 3:塔司管理 4:吊钩可视化 5:主动安全防碰撞 6:基于AI的无人机巡检系统
      typelist: [],
      addOpen: false,
      menuList: [],
      radioStatus: null, // 1是;2否
      queryParams: {
        // type: '6',
        pageSize: '10',
        pageNum: 1,
        company: null,
        pushMp: null,
        pushMpFlag: null,
        pushOfficialWebsite: null,
        pushOfficialWebsiteFlag: null
      },
      radioOptions: [
        { value: 1, label: '是' },
        { value: 2, label: '否' }
      ],
      typeOptions: [
        { value: 1, label: '轮播图' },
        { value: 2, label: 'logo' }
      ]
    }
  },
  methods: {
    handleSizeChange(val) {
      this.queryParams.pageSize = val
      this.getMenus()
    },
    handleCurrentChange(val) {
      this.queryParams.pageNum = val
    },
    handleEdit(e) {
      if (e) {
        console.log(e, '当前选择')
        if (
          e.row.subOfficialWebsiteMenus &&
          e.row.subOfficialWebsiteMenus.length
        ) {
          e.row.isChild = false
        } else {
          e.row.isChild = true
        }
        this.editUnit = JSON.parse(JSON.stringify(e.row))
      }
      // 显示弹框
      this.editState = true
    },
    getMenus() {
      productMenus().then((res) => {
        console.log(res, '菜单')
        if (res.code == 200) {
          // this.menuList = res.data

          res.data.find((item) => {
            if (item.id == '3') {
              this.menuList = item.subOfficialWebsiteMenus
            }
          })
          // console.log(this.menuList, '菜单列表')
        }
      })
    },
    // 删除
    handleDelete(row) {
      console.log(row, '当前选择')
      this.$confirm('确认删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          let delparams = {
            id: row.row.id
          }
          menuDelete(delparams).then((res) => {
            console.log(res, '删除')
            if (res.code == 200) {
              this.$message({
                type: 'success',
                message: '删除成功!'
              })
              this.getMenus()
            } else {
              this.$message({
                type: 'error',
                message: '删除失败!'
              })
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    // 添加子菜单
    handleAddMenu(row) {
      console.log(row, '当前选择')
      this.addOpen = true
      this.title = '添加子菜单'
      this.form = {
        link: 'product.html',
        parentId: row.row.id
      }
    },
    // 新增菜单
    addMenu() {
      this.addOpen = true
      this.title = '新增主菜单'
      this.form = {
        link: 'smart-product.html',
        //orders一个随机正整数，用于排序
        orders: Math.floor(Math.random() * 100),
        parentId: 3
      }
    },
    // 取消
    cancel() {
      this.addOpen = false
      this.form = {}
      this.title = ''
    },
    // 提交菜单表单
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.$loading()
          let params = {
            ...this.form
          }
          console.log(params, '提交子菜单表单')
          menuAdd(params).then((res) => {
            if (res.code == 200) {
              this.addOpen = false
              this.$message({
                message: '添加成功',
                type: 'success'
              })
              this.getMenus()
            } else {
              this.$message({
                message: res.data,
                type: 'error'
              })
            }
          })
          setTimeout(() => {
            this.$loading().close()
          }, 1000)
        } else {
          return false
        }
      })
    },
    // 菜单编辑
    changeDict(infos) {
      let params = {
        ...infos
      }
      // console.log(params, '修改')
      if (params.id) {
        productMenusUpdate({
          id: params.id,
          title: params.title,
          orders: params.orders
        }).then((res) => {
          if (res.code == 200) {
            this.editState = false
            this.$message({
              message: '修改成功',
              type: 'success'
            })
            this.getMenus()
          } else {
            this.$message({
              message: res.data,
              type: 'error'
            })
          }
        })
      } else {
        menuAdd(params).then((res) => {
          // console.log(res.data, '创建')
          if (res.code == 200) {
            this.editState = false
            this.$message({
              message: '添加成功',
              type: 'success'
            })
            this.getMenus()
          } else {
            this.$message({
              message: res.data,
              type: 'error'
            })
          }
        })
      }
      setTimeout(() => {
        this.$loading().close()
      }, 1000)
    },

    // 模糊查询
    dictSearch() {
      this.queryParams.pageNum = 1
      this.getDictList()
    },
    toCreate(e) {
      // console.log(e, '类型')
      this.$router.push({
        path: '/product/Create',
        query: { type: e.type, id: e.id }
      })
    },
    tableRowClassName({ row }) {
      if (row.lastLevel) {
        return 'parent-row'
      }
      return ''
    }

    // // radio选择
    // radioChange(el, type) {
    //   console.log(el, '当前选择')
    //   this.queryParams.pageNum = 1
    //   this.queryParams[type] = el
    //   this.getDictList()
    // }
  },
  mounted() {
    this.getMenus()
    // this.getDictList()
  }
}
</script>

<style>
.cardType {
  display: inline-block;
  width: 30%;
  padding: 20px 0;
  text-align: center;
  margin: 1%;
  border-radius: 5px;
  background-color: aliceblue;
  border: 1px solid #4aabe2;
}
.disabled {
  display: inline-block;
  width: 30%;
  padding: 20px 0;
  text-align: center;
  margin: 1%;
  border-radius: 5px;
  background-color: rgb(243 243 243);
  border: 1px solid #dbdbdb;
}
.el-table .parent-row {
  background-color: #fafafa;
  font-weight: 600; /* 示例字体加粗 */
  font-size: 18px;
  color: rgb(104, 190, 239);
}
</style>
